<template>
  <div class="h-full overflow-auto">
    <!-- 关联监控   -->
    <div v-for="item of monitorList" :key="item.id" class="h-1/3 w-full">
      <div class="monitor-name">{{ item.cameraName }}</div>
      <div class="monitor border" @click="openMonitorDialog(item)">
        <YSPlayer :code="item.cameraCode" :pIid="item.pIid" class="w-full h-full"></YSPlayer>
      </div>
    </div>

    <!-- 监控弹窗 -->
    <monitor-view-dialog
      :code="currentMonitor.cameraCode"
      :pIid="currentMonitor.pIid"
      v-if="monitorDetailVisible"
      @close="closeMonitorDialog"
    ></monitor-view-dialog>

    <!-- 左侧菜单 -->
    <DeviceLedgerTabList
      @changeTab="changeTab"
      activeTab="DeviceMonitor"
      :collapsePanel="collapsePanel"
    ></DeviceLedgerTabList>
  </div>
</template>

<script>
import { DeviceCameraRelationApi } from '@wiz-api/tag-management'
import MonitorViewDialog from './components/MonitorViewDialog'
import DeviceLedgerTabList from './DeviceLedgerTabList'

const deviceCameraRelationApi = new DeviceCameraRelationApi()

const YSPlayer = () => {
  return import('../components/video/YSPlayer/YSPlayer')
}

export default {
  name: 'DeviceRealTimeInfo',
  components: {
    YSPlayer,
    MonitorViewDialog,
    DeviceLedgerTabList,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    collapsePanel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      monitorList: [],
      currentMonitor: {
        code: '',
        pIid: '',
      },
      keyword: '',
      monitorDetailVisible: false,
      total: 0, // 绑定的监控数量总数
    }
  },
  watch: {
    transferProps: {
      handler() {
        this.getList()
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  methods: {
    changeTab(data) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: data.code,
            origin: data.origin,
            name: data.name,
            hideTitle: data.hideTitle,
          },
          position: 'right',
          type: 'tags',
          props: this.transferProps,
        },
      })
      window.dispatchEvent(openEvent)
    },
    // 打开监控弹窗
    openMonitorDialog(data) {
      this.currentMonitor = data
      this.monitorDetailVisible = true
    },
    // 关闭监控弹窗
    closeMonitorDialog() {
      this.currentMonitor = {}
      this.monitorDetailVisible = false
    },
    async getList() {
      this.loading = true
      // 暂时最多加载99个监控，后续需优化
      const params = {
        deviceCode: this.transferProps.code,
        skipCount: 1,
        maxResultCount: 99,
      }
      const [err, res] = await deviceCameraRelationApi.getList(params)
      this.loading = false
      if (!err && res) {
        this.monitorList = res.items
        this.total = res.totalCount
      }
    },
  },
  created() {},
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      line-height: 14px;
    }
  }
}

::v-deep {
  .info-form {
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-form-item__label {
      line-height: 20px;
      padding-bottom: 5px;
    }
    .el-input {
      .el-input__inner {
        border-color: #fff !important;
      }
    }
  }
}

.monitor-name {
  line-height: 36px;
  font-size: 16px;
  color: #fff;
}
.monitor {
  height: calc(100% - 36px);
  width: 100%;
  cursor: pointer;
}
</style>
